<ap-modal
  #modal
  [style]="'width: 50%'"
  appModalId="tax-news-detail-modal"
  [title]="taxNews()?.name ?? ''">
  <div class="p-4 information-text border rounded ap-text-neutral-14">
    <div class="mb-2">
      {{ taxNews()?.date | date: 'dd MMMM yyyy' }}
    </div>
    <div
      gstarInternalLinks
      [innerHTML]="
        taxNews()?.description ?? '' | blankLinks | safe: 'html'
      "></div>
  </div>
</ap-modal>
